import React, { useState } from "react";
import { ArrowRepeat } from "react-bootstrap-icons";
import Iframe from "../Iframe";

const initialState = {
  src: "",
  width: "600",
  height: "400",
  title: "An external page",
  allow: "",
  frameBorder: "0",
  allowFullScreen: false,
};

const WIDTH_MIN = 100,
  WIDTH_MAX = 1920;
const HEIGHT_MIN = 100,
  HEIGHT_MAX = 1024;

const clamp = (value, min, max) =>
  Math.max(min, Math.min(max, Number(value) || min));

const IframeGenerator = ({ openModal }) => {
  const [values, setValues] = useState(initialState);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Range or input for width
  const handleWidthChange = (val) =>
    setValues((old) => ({
      ...old,
      width: clamp(val, WIDTH_MIN, WIDTH_MAX).toString(),
    }));

  // Range or input for height
  const handleHeightChange = (val) =>
    setValues((old) => ({
      ...old,
      height: clamp(val, HEIGHT_MIN, HEIGHT_MAX).toString(),
    }));

  const handleReset = () => setValues(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();
    openModal(generateCode());
  };

  const generateCode = () => {
    const { src, width, height, title, allow, frameBorder, allowFullScreen } =
      values;
    const attrs = [
      `src="${src}"`,
      `width="${width}"`,
      `height="${height}"`,
      title ? `title="${title}"` : "",
      allow ? `allow="${allow}"` : "",
      frameBorder ? `frameBorder="${frameBorder}"` : "",
      allowFullScreen ? "allowFullScreen" : "",
    ]
      .filter(Boolean)
      .join(" ");
    return `<Iframe ${attrs} />`;
  };

  return (
    <div className="grid m-auto p-2 max-w-xl">
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-6">
          {/* SRC */}
          <div className="my-2">
            <label className="text-sm block text-gray-700 font-bold mb-2">
              Source (required)
            </label>
            <input
              name="src"
              type="url"
              required
              value={values.src}
              onChange={handleChange}
              className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="https://external_page.com"
            />
          </div>

          {/* WIDTH Range & Input */}
          <div className="my-5 flex items-center justify-center">
            <label
              htmlFor="width-range"
              className="text-sm block text-gray-700 font-bold mb-2"
            >
              Width
            </label>
            <input
              id="width-range"
              type="range"
              min={WIDTH_MIN}
              max={WIDTH_MAX}
              value={values.width}
              onChange={(e) => handleWidthChange(e.target.value)}
              className="range range-primary range-sm mx-4 w-44"
            />
            <input
              type="number"
              min={WIDTH_MIN}
              max={WIDTH_MAX}
              value={values.width}
              onChange={(e) => handleWidthChange(e.target.value)}
              className="w-20 ml-3 p-1 border rounded"
            />
            <span className="ml-2 text-xs text-gray-500">px</span>
          </div>

          {/* HEIGHT Range & Input */}
          <div className="my-5 flex items-center justify-center">
            <label
              htmlFor="height-range"
              className="text-sm block text-gray-700 font-bold mb-2"
            >
              Height
            </label>
            <input
              id="height-range"
              type="range"
              min={HEIGHT_MIN}
              max={HEIGHT_MAX}
              value={values.height}
              onChange={(e) => handleHeightChange(e.target.value)}
              className="range range-primary range-sm mx-4 w-44"
            />
            <input
              type="number"
              min={HEIGHT_MIN}
              max={HEIGHT_MAX}
              value={values.height}
              onChange={(e) => handleHeightChange(e.target.value)}
              className="w-20 ml-3 p-1 border rounded"
            />
            <span className="ml-2 text-xs text-gray-500">px</span>
          </div>

          {/* Title */}
          <div>
            <label className="text-sm block text-gray-700 font-bold mb-2">
              Title
            </label>
            <input
              name="title"
              type="text"
              value={values.title}
              onChange={handleChange}
              className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              //placeholder="Title"
            />
          </div>

          {/* AllowFullScreen */}
          <div className="flex gap-6 items-center">
            <label className="flex items-center text-sm font-medium gap-2">
              <input
                name="allowFullScreen"
                type="checkbox"
                checked={values.allowFullScreen}
                onChange={handleChange}
                className="form-checkbox"
              />
              Allow Full Screen
            </label>
          </div>

          {/* Action buttons */}
          <div className="flex flex-row m-auto mt-4">
            <button type="submit" className="btn m-auto mx-4">
              Create Iframe
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="btn btn-circle m-auto"
            >
              <ArrowRepeat size={30} />
            </button>
          </div>
        </div>
      </form>

      {/* Preview and generated code */}
    </div>
  );
};

export default IframeGenerator;
